module.exports = __webpack_public_path__ + "static/img/MP.746e6597.svg";